import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32a11a76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "colors" }
const _hoisted_2 = { class: "colors__left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "brush-map__subtitle" }, "PLUS", -1))
const _hoisted_4 = { class: "colors__left-list" }
const _hoisted_5 = { class: "colors__right" }
const _hoisted_6 = { class: "colors__right-list" }

import { ref } from 'vue'
import BrushMapListItem from './components/BrushMapListItem.vue'
import { BrushMapAddedBrushes } from '@/pages/BrushMapPage/brushMapAddedBrushes'
import { SelectedBrushType } from '@/shared/types'
import { INTERPROX_COLOR_LIST } from '@/shared/constants/brushMapFirms'

interface Props {
  brushMapBrushes: BrushMapAddedBrushes
}


export default /*#__PURE__*/_defineComponent({
  props: {
    brushMapBrushes: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        _createVNode(BrushMapListItem, {
          brushMapBrushes: __props.brushMapBrushes,
          firstPosition: 0,
          list: _unref(INTERPROX_COLOR_LIST),
          secondPosition: 3
        }, null, 8, ["brushMapBrushes", "list"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        _createVNode(BrushMapListItem, {
          brushMapBrushes: __props.brushMapBrushes,
          firstPosition: 3,
          list: _unref(INTERPROX_COLOR_LIST),
          secondPosition: 6
        }, null, 8, ["brushMapBrushes", "list"])
      ])
    ])
  ]))
}
}

})